import {config} from "../../AppConfig";

async function createS3UploadUrl(key) {
    const result = await fetch(`${config.url.API_BASE}/api/admin/release/upload?key=${key}`, {
        method: "POST",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}

async function publishRelease(key, updates, notes) {
    const payload = {
        updates: updates,
        notes: notes
    }

    const result = await fetch(`${config.url.API_BASE}/api/admin/release/publish?key=${key}`, {
        method: "POST",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(payload)
    });

    return {
        status: result.status,
        data: null
    };
}

async function searchUsers(page, query = "", status = "") {
    const result = await fetch(`${config.url.API_BASE}/api/admin/users?page=${page}&q=${query}&status=${status}`, {
        method: "GET",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}

async function searchPurchaseLinks(page, query = "", status = "") {
    const result = await fetch(`${config.url.API_BASE}/api/admin/links?page=${page}&q=${query}&status=${status}`, {
        method: "GET",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}


async function unbindHwid(licenceId) {
    const result = await fetch(`${config.url.API_BASE}/api/admin/licences/${licenceId}/unbind-hwid`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}

async function unbindDiscord(userId) {
    const result = await fetch(`${config.url.API_BASE}/api/admin/users/${userId}/unbind-discord`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}

async function disablePurchaseLink(linkId) {
    const result = await fetch(`${config.url.API_BASE}/api/admin/links/${linkId}/disable`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}
async function enablePurchaseLink(linkId) {
    const result = await fetch(`${config.url.API_BASE}/api/admin/links/${linkId}/enable`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}

async function searchLicences(page, query = "", status = "") {
    const result = await fetch(`${config.url.API_BASE}/api/admin/licences?page=${page}&q=${query}&status=${status}`, {
        method: "GET",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return {
        status: result.status,
        data: await result.json(),
    };
}

export const adminUserService = {
    searchUsers,
    unbindHwid,
    unbindDiscord,
    searchPurchaseLinks,
    disablePurchaseLink,
    enablePurchaseLink,
    searchLicences,
    createS3UploadUrl,
    publishRelease
};
